// frontend/src/services/contactMessageService.js
import API from './api';

const ContactMessageService = {
  // Public: Submit contact form
  submitContactForm: async (formData) => {
    try {
      const response = await API.post('/contact-messages', formData);
      return response.data;
    } catch (error) {
      console.error('Submit contact form error:', error);
      throw error;
    }
  },

  // Admin: Get all messages
  getAllMessages: async (filters = {}) => {
    try {
      let url = '/contact-messages';
      const params = new URLSearchParams();
      
      if (filters.status) params.append('status', filters.status);
      if (filters.search) params.append('search', filters.search);
      
      if (params.toString()) {
        url += '?' + params.toString();
      }
      
      const response = await API.get(url);
      return response.data;
    } catch (error) {
      console.error('Get all messages error:', error);
      throw error;
    }
  },

  // Admin: Get single message
  getMessageById: async (id) => {
    try {
      const response = await API.get(`/contact-messages/${id}`);
      return response.data;
    } catch (error) {
      console.error('Get message by id error:', error);
      throw error;
    }
  },

  // Admin: Mark as read
  markAsRead: async (id) => {
    try {
      const response = await API.get(`/contact-messages/${id}/mark-read`);
      return response.data;
    } catch (error) {
      console.error('Mark as read error:', error);
      throw error;
    }
  },

  // Admin: Mark as replied
  markAsReplied: async (id) => {
    try {
      const response = await API.get(`/contact-messages/${id}/mark-replied`);
      console.log('Mark as replied response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Mark as replied error:', error);
      throw error;
    }
  },

  // Admin: Delete message
  deleteMessage: async (id) => {
    try {
      const response = await API.delete(`/contact-messages/${id}`);
      return response.data;
    } catch (error) {
      console.error('Delete message error:', error);
      throw error;
    }
  }
};

export default ContactMessageService;